import { ErrorConeIcon } from '@components/icons/ErrorConeIcon';
import { useTranslation } from '../../hooks/useTranslation';
import { StatusMessage } from './StatusMessage';

export function ErrorState() {
  const { t } = useTranslation();

  return (
    <StatusMessage
      role="alert"
      aria-live="polite"
      icon={<ErrorConeIcon aria-hidden="true" />}
    >
      {t('error_state')}
    </StatusMessage>
  );
}
